<template>
  <div>
    <div class="page_title">患者售后申请记录</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="searchtitle">订单编号</span>
            <el-input placeholder="请输入"
                      v-model="order_sn"
                      style="width: 150px; margin-left: 8px"
                      @input="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">患者姓名</span>
            <el-input placeholder="请输入"
                      v-model="user_name"
                      style="width: 150px; margin-left: 8px"
                      clearable
                      @input="search"></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">申请时间</span>
            <el-date-picker v-model="date"
                            type="daterange"
                            range-separator="~"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            clearable
                            @change="search"
                            style="width: 225px; margin-left: 8px"></el-date-picker>
          </div>
          <div class="item">
            <span class="searchtitle">联系电话</span>
            <el-input placeholder="请输入"
                      v-model="phone"
                      style="width: 150px; margin-left: 8px"
                      clearable
                      @input="search"></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">售后原因</span>
            <el-select v-model="refund_desc"
                       placeholder="请选择"
                       style="width: 150px; margin-left: 8px"
                       @change="search"
                       clearable="">
              <el-option v-for="item in reason_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="searchtitle">状态</span>
            <el-select v-model="status"
                       placeholder="请选择"
                       style="width: 150px; margin-left: 8px"
                       @change="search"
                       clearable>
              <el-option label="已处理"
                         :value="1">
              </el-option>
              <el-option label="待处理"
                         :value="0">
              </el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="searchtitle">处理意见</span>
            <el-select v-model="type"
                       placeholder="请选择"
                       style="width: 150px; margin-left: 8px"
                       @change="search"
                       clearable="">
              <el-option v-for="item in typeList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-button type="info"
                       style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 12px;
              "
                       @click="search">查询</el-button>
          </div>

        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column label="申请时间"
                             prop="create_time">
            </el-table-column>
            <el-table-column label="订单编号"
                             prop="order_sn">
            </el-table-column>
            <el-table-column label="患者姓名"
                             prop="user_name">
            </el-table-column>
            <el-table-column label="联系电话"
                             prop="phone">
            </el-table-column>
            <el-table-column label="售后原因"
                             prop="refund_desc">
            </el-table-column>

            <el-table-column label="状态"
                             prop="status">
              <template slot-scope="scope">
                {{!scope.row.status ? '待处理' :'已处理'}}
              </template>
            </el-table-column>

            <el-table-column label="处理意见">
              <template slot-scope="scope">
                <div class="remark">
                  <el-tooltip :content="typeTextMethod(scope.row.type,scope.row.customer_service_remark)"
                              placement="right"
                              effect="light">
                    <span>
                      {{scope.row.type | typeText}} <span v-if="scope.row.customer_service_remark">({{scope.row.customer_service_remark}})</span>
                    </span>
                  </el-tooltip>

                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="toDetail(scope.row.id)"
                           :disabled="module_id_array[0] ? !module_id_array.includes('762') : false">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination v-show="totalNum > 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import Pagination from '@/components/Pagination';
export default {
  inject: ['reload'],
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      tableData: [],
      pagination: {
        page: 1,
        pageNumber: 10
      },
      order_sn: '',
      user_name: '',
      phone: '',
      refund_desc: '',
      date: [],
      status: 0,
      type: '',
      reason_list: [
        {
          label: '物流一直未送达',
          value: '物流一直未送达'
        },
        {
          label: '质量问题',
          value: '质量问题'
        },
        {
          label: '少件/漏发',
          value: '少件/漏发'
        },
        {
          label: '包装/货物破损',
          value: '包装/货物破损'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      typeList: [
        {
          label: '无须处理',
          value: 1
        },
        {
          label: '售后退款',
          value: 2
        },
        {
          label: '作废退款',
          value: 3
        },
        {
          label: '申请补发',
          value: 4
        }
      ]
    };
  },
  filters: {
    typeText(val) {
      switch (val) {
        case 1:
          return '无须处理';
        case 2:
          return '售后退款';
        case 3:
          return '作废退款';
        case 4:
          return '申请补发';
        default:
          return '';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  activated() {
    this.getList();
  },
  methods: {
    //
    typeTextMethod(type, remark) {
      let text = '';
      switch (type) {
        case 1:
          text = '无须处理';
          break;
        case 2:
          text = '售后退款';
          break;
        case 3:
          text = '作废退款';
          break;
        case 4:
          text = '申请补发';
          break;
        default:
          text = '';
          break;
      }
      if (remark) {
        return `${text}(${remark})`;
      }
      return text;
    },
    //
    //获取列表
    getList() {
      let data = {
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber,
        order_sn: this.order_sn,
        user_name: this.user_name,
        phone: this.phone,
        refund_desc: this.refund_desc,
        status: this.status,
        type: this.type
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/order/getorderServiceList', data)
        .then((res) => {
          this.totalNum = res.data.total;
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            return item;
          });
        });
    },
    //详情
    toDetail(id) {
      this.$router.push({ path: 'refunddetail', query: { id } });
    },

    search() {
      this.pagination.page = 1;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .searchtitle {
    display: inline-block;
    width: 60px;
    text-align: right;
    box-sizing: border-box;
  }
  .item {
    margin-right: 10px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
.remark {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>


